
import {
  defineComponent, computed,
} from 'vue';

export default defineComponent({
  props: {
    placement: {
      type: String,
      required: false,
      default: () => 'bottom',
    },
  },

  setup() {
    const {
      ioappConfig: {
        svg: {
          clouds,
        },
      },
    } = window;

    const cloudsSvg = computed<string>(() => atob(clouds));

    return {
      cloudsSvg,
    };
  },
});
